import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import PodcastsStories from "@pages/Home/Podcasts/PodcastStories";
import Card from "@particles/card/Card";
import { sectionNavigationItems } from "@util/constant";
import { cn } from "@util/helpers";

type podcastProps = {
  /** Additionl styling for the component */
  className?: string;
  /** The list of the article card props */
  cardProps: ComponentProps<typeof Card>[];
};

const section = sectionNavigationItems.podcasts;

/**
 * Renders the Home - podcasts section with a title and a list of articles.
 * https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1312-2257&t=g7P8QlYHW3Ymfii6-4
 */
const Podcasts = ({
  cardProps,
  className,
}: podcastProps): React.ReactElement => {
  return (
    <section
      className={className}
      data-testid="homepage-podcasts-stories-component"
    >
      <BlockTitle link={section?.link} text={section?.label?.toUpperCase()} />

      <div className={cn("stories flex flex-wrap")}>
        {cardProps.map((card, index) => {
          return (
            <PodcastsStories cardProps={card} index={index} key={card.id} />
          );
        })}
      </div>
    </section>
  );
};

export default Podcasts;
